// extracted by mini-css-extract-plugin
export var answerContent = "single-faq-module--answer-content--hXb-I";
export var chevron = "single-faq-module--chevron--hyYBW";
export var faq = "single-faq-module--faq--r9aHu";
export var faqOpen = "single-faq-module--faq-open--Mv60b";
export var question = "single-faq-module--question--dYZat";